import { c as _c } from "react/compiler-runtime";
import { getCountryFromCode } from '@onefootprint/core';
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import { useTranslation } from 'react-i18next';

// Country names are translated in the ui package, where the country and phone pickers read them.
export const useCountryName = () => {
  const $0 = _c(2);
  const {
    t
  } = useTranslation("ui");
  let t0;
  if ($0[0] !== t) {
    t0 = code => {
      const label = getCountryFromCode(code)?.label;
      if (!code || !label) {
        return label;
      }
      return t($ => $.global.countries[code as keyof typeof $.global.countries], {
        defaultValue: label
      });
    };
    $0[0] = t;
    $0[1] = t0;
  } else {
    t0 = $0[1];
  }
  return t0;
};